export default {
  fi: {
    ConfirmScene: {
      emailConfirmed: 'Sähköpostisi on vahvistettu',
      backLink: 'Takaisin kirjautumissivulle',
    },
  },
};
